const selectAnnouncementDetail = state => {
  return {
    ...state.dashboard.announcementDetail
  };
};

const selectDashboardInfo = state => {
  return {
    ...state.dashboard.info
  };
};

export { selectAnnouncementDetail, selectDashboardInfo };
